import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../services/validation-service/validation.service";
import {LeadService} from "../../../services/lead-service/lead.service";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {WebLeadType} from "../../../model/leads/WebLeadType";
import {Quote} from "../../../model/Quote";
import {ActivationControllerService} from "../../../api/services/activation-controller.service";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-quote-step-one',
  templateUrl: './quote-step-three.component.html'
})
export class QuoteStepThreeComponent implements OnInit, AfterViewInit {
  acceptDiscoveryInsureTerms = false;
  leadAllocatedToAgent = false;
  enableActivationJourney = false;
  selectedQuote: Quote;
  showAdditionalBenefits = false;
  corePlanButtonClicked = false;
  corePlanModalOpened = false;
  @ViewChild('formStart') formStart: ElementRef;
  @ViewChild('corePlanModal') corePlanModal: ElementRef;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public activationControllerService: ActivationControllerService,
              public validationService: ValidationService,
              private leadService: LeadService,
              private gtmService: GtmService) { }

  ngOnInit() {
    if (!this.quotationService.leadUpdated) {
      this.updateLead('pageLoad');
    }
    this.quotationService.getActivateButtonStatus().subscribe((response: boolean) => {
      this.enableActivationJourney = response;
    })
  }

  ngAfterViewInit() {
    this.quotationService.scrollToPosition(this.formStart.nativeElement.getBoundingClientRect().top);
  }

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  trackingUserInteraction (event) {
    const leavingContent = event.pageY;
    if (leavingContent <= 2394 && !this.corePlanModalOpened) {
      this.corePlanModalOpened = true;
      this.corePlanModal.nativeElement.click();
      this.quotationService.scrollToTop();
    }
  }

  setLeadComment (clickedElement?: string) {
    if (clickedElement === 'Request') {
      this.corePlanButtonClicked = true;
    }
    this.updateLead('corePlan');
  }

  activateNow(selectedQuote: Quote) {
    this.reloadJCF();
    this.selectedQuote = selectedQuote;
    this.quotationService.scrollToTop();
    this.gtmService.formName = 'insure_online_activation';
    this.gtmService.postGtmEvent('form_step_complete', 'select_your_quote', 4);
    this.updateLead('activateNow', selectedQuote);
    this._selectQuote();
  }

  speakToAnAgent(selectedQuote: Quote) {
    this.gtmService.formName = 'insure_60_second_quote';
    this.gtmService.postGtmEvent('form_step_complete', 'speak_to_us', 3);
    this.updateLead('speakToUs', selectedQuote);
  }

  private _selectQuote() {
    this.gtmService.postGtmEvent('form_step_complete', 'give_consent_and_continue', 4);
    this.activationControllerService.activationV1SelectQuotePost(this.selectedQuote.quoteId).subscribe(response => {
      this.router.navigateByUrl('activation-planholder-details');
    }, error => {
      this.quotationService.error = true;
    });
  }

  private updateLead(action, selectedQuote?: Quote) {
    if (action === 'pageLoad') {
      this.quotationService.leadUpdated = true;
      const firstQuote: Quote = this.quotationService.quoteResponse.quoteList[0];
      const secondQuote: Quote = this.quotationService.quoteResponse.quoteList[1];
      this.leadService.quoteDetail = firstQuote.quoteNo + ', ' + firstQuote.plan.planDescr + ': R' + firstQuote.totalPremiumAmt + 'pm | '
        + secondQuote.quoteNo + ', ' + secondQuote.plan.planDescr + ': R' + secondQuote.totalPremiumAmt + 'pm';
      this.leadService.updateLead(WebLeadType.WEB_LEAD_2).subscribe();
    } else if (action === 'activateNow') {
      this.leadService.quoteDetail = 'Selected quote: ' + selectedQuote.quoteNo + ', ' + selectedQuote.plan.planDescr + ': R' + selectedQuote.totalPremiumAmt + 'pm';
      this.leadService.insureRecommendedQuote = 'Activate Now';
      this.leadService.updateLead(WebLeadType.ONLINE_ACTIVATION_STARTED).subscribe();
    } else if (action === 'speakToUs') {
      this.leadService.quoteDetail = 'Selected quote: ' + selectedQuote.quoteNo + ', ' + selectedQuote.plan.planDescr + ': R' + selectedQuote.totalPremiumAmt + 'pm';
      this.leadService.updateLead(WebLeadType.WEB_LEAD_1).subscribe(response => {
        this.leadAllocatedToAgent = true
      });
    } else if (action === 'corePlan') {
      if (this.corePlanButtonClicked === true) {
        this.leadService.updateLead(WebLeadType.WEB_LEAD_1, null, null, null,
          null, null, 'WEBSITE', 'call back up to 20% off*').subscribe();
      } else {
        this.leadService.updateLead(WebLeadType.WEB_LEAD_1, null, null, null,
          null, null, 'WEBSITE', 'call back up to 20% off').subscribe();
      }
    }
  }

}

